import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
export var createEditorStateNotificationPlugin = function createEditorStateNotificationPlugin(onEditorStateUpdated) {
  return new SafePlugin({
    view: function view() {
      return {
        update: function update(view, oldEditorState) {
          onEditorStateUpdated({
            oldEditorState: oldEditorState,
            newEditorState: view.state
          });
        }
      };
    }
  });
};